<template>
    <div class="app-contacts-contacts-create">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Criar Contato</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Formulário de contato [ Criação, Edição ] -->
        <mu-form-contact type="create"></mu-form-contact>

    </div>
</template>

<script>
    export default {
        name: 'app-contacts-contacts-create',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Contatos',
                        route: 'app.contacts',
                        disabled: false
                    },
                    {
                        text: 'Meus Contatos',
                        route: 'app.contacts.contacts',
                        disabled: false
                    },
                    {
                        text: 'Criar Contato',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>
